import React from 'react';
import { Battery, Signal, Wifi } from 'lucide-react';
interface PhoneFrameProps {
  children: React.ReactNode;
  className?: string;
}
export function PhoneFrame({
  children,
  className = ''
}: PhoneFrameProps) {
  const currentTime = new Date().toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).replace(' ', '');
  return <div className={`relative mx-auto h-[844px] w-[390px] overflow-hidden rounded-[40px] border-[8px] border-slate-900 bg-white shadow-2xl ring-1 ring-slate-900/5 ${className}`} data-id="element-143">
      {/* Dynamic Island / Notch Area */}
      <div className="absolute left-1/2 top-0 z-50 h-[30px] w-[120px] -translate-x-1/2 rounded-b-2xl bg-slate-900" data-id="element-144"></div>

      {/* Status Bar */}
      <div className="absolute top-0 z-40 flex w-full items-center justify-between px-6 pt-3 text-xs font-semibold text-slate-900" data-id="element-145">
        <span data-id="element-146">9:41</span>
        <div className="flex items-center gap-1.5" data-id="element-147">
          <Signal className="h-3.5 w-3.5" strokeWidth={2.5} data-id="element-148" />
          <Wifi className="h-3.5 w-3.5" strokeWidth={2.5} data-id="element-149" />
          <Battery className="h-3.5 w-3.5" strokeWidth={2.5} data-id="element-150" />
        </div>
      </div>

      {/* Main Content Area */}
      <div className="h-full w-full overflow-y-auto bg-slate-50 pt-12 pb-8 scrollbar-hide" data-id="element-151">
        {children}
      </div>

      {/* Home Indicator */}
      <div className="absolute bottom-2 left-1/2 z-50 h-1 w-32 -translate-x-1/2 rounded-full bg-slate-900/20" data-id="element-152"></div>
    </div>;
}